module.exports = __webpack_public_path__ + "img/poliglotk2.87e95f22.png";